import { useEffect, useState } from "react";
import { api, fmtEur } from "../../lib/api";
import { OFFER_LABELS } from "../../lib/labels";

const Kpi = ({ label, value, sub, testid }) => (
  <div className="bg-white border border-[#E8E2D8] p-4" data-testid={testid}><p className="font-display text-3xl">{value ?? "—"}</p><p className="text-xs text-[#57534E]">{label}</p>{sub && <p className="text-xs text-[#8C857B] mt-1">{sub}</p>}</div>
);

export default function Stats() {
  const [days, setDays] = useState(90);
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats", { params: { days } }).then((r) => setS(r.data)); }, [days]);
  if (!s) return <p className="text-sm">Chargement…</p>;
  const f = s.funnel;
  const abandon = Object.entries(s.abandon_by_step).sort();
  const sources = Object.entries(s.sources);
  return (
    <div data-testid="admin-stats">
      <div className="flex flex-wrap justify-between items-end gap-4">
        <div><p className="k-eyebrow">Mesure commerciale</p><h1 className="k-h2 mt-2">Demandes, devis, transformation.</h1></div>
        <select className="k-input w-auto py-2 text-sm" value={days} onChange={(e) => setDays(Number(e.target.value))} data-testid="stats-period">
          <option value={30}>30 jours</option><option value={90}>90 jours</option><option value={365}>12 mois</option>
        </select>
      </div>
      <p className="text-xs text-[#8C857B] mt-3">{s.note}</p>
      <div className="mt-6 grid gap-3 grid-cols-2 lg:grid-cols-4">
        <Kpi label="Demandes reçues" value={s.requests} testid="kpi-requests" />
        <Kpi label="Demandes qualifiées" value={s.qualified} testid="kpi-qualified" />
        <Kpi label="Devis émis" value={s.quotes_emitted} sub={`${fmtEur(s.quotes_emitted_amount)} HT${s.quotes_without_amount ? ` · ${s.quotes_without_amount} sans montant` : ""}`} testid="kpi-quotes" />
        <Kpi label="Devis acceptés" value={s.quotes_accepted} sub={`${fmtEur(s.quotes_accepted_amount)} HT`} testid="kpi-accepted" />
        <Kpi label="Taux de transformation" value={s.conversion_rate != null ? `${s.conversion_rate} %` : null} sub="acceptés / émis" testid="kpi-conversion" />
        <Kpi label="Délai moyen jusqu'au devis" value={s.avg_days_to_quote != null ? `${s.avg_days_to_quote} j` : null} testid="kpi-delay" />
        <Kpi label="Clients récurrents" value={s.recurring_clients} sub="plus d'une demande" testid="kpi-recurring" />
      </div>
      <div className="mt-6 grid gap-4 lg:grid-cols-2">
        <section className="bg-white border border-[#E8E2D8] p-5" data-testid="stats-funnel">
          <h2 className="font-display text-xl">Parcours par offre (visiteurs uniques)</h2>
          <table className="w-full text-sm mt-3"><thead className="text-xs text-[#8C857B] text-left"><tr><th>Offre</th><th>Visites</th><th>Formulaires commencés</th><th>Terminés</th><th>Demandes</th></tr></thead>
            <tbody>{Object.keys(OFFER_LABELS).map((o) => <tr key={o} className="border-t border-[#E8E2D8]"><td className="py-2">{OFFER_LABELS[o]}</td><td>{f.offer_view?.[o] || 0}</td><td>{f.form_start?.[o] || 0}</td><td>{f.form_submit?.[o] || 0}</td><td>{s.by_offer[o]}</td></tr>)}</tbody></table>
        </section>
        <section className="bg-white border border-[#E8E2D8] p-5" data-testid="stats-abandon">
          <h2 className="font-display text-xl">Abandons par étape atteinte</h2>
          <ul className="text-sm mt-3">{abandon.map(([k, v]) => <li key={k}>Étape {k} : {v}</li>)}{!abandon.length && <li className="text-[#8C857B]">Pas de données.</li>}</ul>
          <h2 className="font-display text-xl mt-6">Sources connues</h2>
          <ul className="text-sm mt-3">{sources.map(([k, v]) => <li key={k}>{k} : {v}</li>)}{!sources.length && <li className="text-[#8C857B]">Pas de données.</li>}</ul>
        </section>
      </div>
    </div>
  );
}
